import { useQuery } from 'react-query';

import { CommonClaimService } from '../api';

export const GetFullClaimContextQuery = 'GetFullClaimContextQuery';

export const useGetFullClaimContextQuery = ({
  claimId,
}: {
  claimId?: string;
}) => {
  const { data: fullClaim, isLoading } = useQuery(
    [GetFullClaimContextQuery, { claimId }],
    async () => {
      if (!claimId) {
        return undefined;
      }

      const response = await CommonClaimService.getFullClaimContextQuery({
        claimId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {},
  );

  return {
    fullClaim,
    isLoading,
  };
};
